import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * SelectFlag Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Available languages
     */
    @Prop({ type: Array }) languages!: Array<string>

    /**
     * Type of flag image
     * 
     * @values circular, linear, simple, simple-radius, square
     */
    @Prop({ type: String, default: 'simple' }) flagType!: String

    /**
     * Hide SingleLabel Title
     */
    @Prop({ type: Boolean }) noSingleLabelTitle!: boolean;
    
    /**
     * Hide Label of the field
     */
    @Prop({ type: Boolean }) noLabel!: boolean;
}

export default Props;
